/**
 * 二次元コード（046、docs/31 §5）。qrcode-generator（MIT、純粋な JS＝ブラウザでも Node でも動く）で作り、SVG の文字列にする。
 *   ・文字は UTF-8 のバイトで入れる（ライブラリの既定は Latin だけなので差し替える）
 *   ・誤り訂正は M。周りは 4 モジュールの白抜き（規格。docs/31 §11-7）
 *   ・大きさは呼ぶ側が mm で決める（正方形）。モジュールは整数でなく viewBox で拡大縮小
 */
import qrcode from "qrcode-generator";

/** UTF-8 のバイト列（TextEncoder を使わない＝lib に依らない） */
export function utf8Bytes(s: string): number[] {
  const out: number[] = [];
  for (const ch of s) {
    const cp = ch.codePointAt(0)!;
    if (cp < 0x80) out.push(cp);
    else if (cp < 0x800) out.push(0xc0 | (cp >> 6), 0x80 | (cp & 0x3f));
    else if (cp < 0x10000) out.push(0xe0 | (cp >> 12), 0x80 | ((cp >> 6) & 0x3f), 0x80 | (cp & 0x3f));
    else out.push(0xf0 | (cp >> 18), 0x80 | ((cp >> 12) & 0x3f), 0x80 | ((cp >> 6) & 0x3f), 0x80 | (cp & 0x3f));
  }
  return out;
}
qrcode.stringToBytes = utf8Bytes;

export const QR_QUIET = 4;

/** 文字 → SVG（正方形。size は mm）。空なら ""。長すぎて入らなければ "" */
export function qrSvg(text: string, sizeMm: number): string {
  if (!text) return "";
  let q: ReturnType<typeof qrcode>;
  try {
    q = qrcode(0, "M");
    q.addData(text, "Byte");
    q.make();
  } catch {
    return "";
  }
  const n = q.getModuleCount();
  const N = n + QR_QUIET * 2;
  const d: string[] = [];
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (q.isDark(r, c)) d.push(`M${c + QR_QUIET} ${r + QR_QUIET}h1v1h-1z`);
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${N} ${N}" width="${sizeMm}mm" height="${sizeMm}mm" shape-rendering="crispEdges"><rect width="${N}" height="${N}" fill="#fff"/><path d="${d.join("")}" fill="#000"/></svg>`;
}

/** 二次元コードの中身（bind があれば項目の値、無ければ固定の文字） */
export function qrContent(e: { text: string; bind: string | null }, fields: Record<string, string>): string {
  return e.bind ? (fields[e.bind] ?? "") : e.text;
}
